(() => {
  const pageOf = (el) => el.closest('main') || document;
  const sendQuery = (el, query) => document.dispatchEvent(new CustomEvent('rp:faq-search', { detail: { page: pageOf(el), query } }));
  const scrollToElement = (el) => el?.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });

  if (!customElements.get('rp-faq-search')) customElements.define('rp-faq-search', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const input = this.querySelector('input');
      const results = () => pageOf(this).querySelector('rp-faq-hub');
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault(); sendQuery(this, input.value); scrollToElement(results());
      }, { signal });
      input.addEventListener('input', () => sendQuery(this, input.value), { signal });
      this.querySelectorAll('[data-query]').forEach(button => button.addEventListener('click', () => {
        input.value = button.dataset.query; sendQuery(this, input.value); scrollToElement(results());
      }, { signal }));
      document.addEventListener('rp:faq-search', ({ detail }) => {
        if (detail.page === pageOf(this)) input.value = detail.query;
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });

  if (!customElements.get('rp-faq-hub')) customElements.define('rp-faq-hub', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.items = [...this.querySelectorAll('[data-question]')].map(el => ({ el, text: el.textContent.toLocaleLowerCase().normalize('NFKC'), initiallyOpen: el.open }));
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.links = [...this.querySelectorAll('[data-category]')];
      this.filter('');
      document.addEventListener('rp:faq-search', ({ detail }) => {
        if (detail.page === pageOf(this)) this.filter(detail.query);
      }, { signal });
      this.querySelector('[data-clear]')?.addEventListener('click', () => {
        sendQuery(this, '');
        pageOf(this).querySelector('rp-faq-search input')?.focus();
      }, { signal });
      this.links.forEach(link => link.addEventListener('click', (event) => {
        event.preventDefault(); sendQuery(this, '');
        const target = this.groups.find(group => group.dataset.group === link.dataset.category);
        this.activate(link.dataset.category); scrollToElement(target);
      }, { signal }));
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting && !entry.target.hidden).sort((a,b) => a.boundingClientRect.top-b.boundingClientRect.top);
        if (visible.length) this.activate(visible[0].target.dataset.group);
      }, { rootMargin: '-25% 0px -55% 0px', threshold: 0 });
      this.groups.forEach(group => this.observer.observe(group));
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        sendQuery(this, '');
        const details = event.target.closest('[data-question]');
        if (details) details.open = true;
      }, { signal });
    }
    activate(id) { this.links.forEach(link => link.setAttribute('aria-current', String(link.dataset.category === id))); }
    filter(query) {
      const words = query.trim().toLocaleLowerCase().normalize('NFKC').split(/\s+/).filter(Boolean);
      let count = 0;
      this.items.forEach(item => {
        const matches = words.every(word => item.text.includes(word));
        item.el.hidden = !matches;
        item.el.open = words.length ? matches : item.initiallyOpen;
        if (matches) count++;
      });
      this.groups.forEach(group => {
        const visible = group.querySelectorAll('[data-question]:not([hidden])').length;
        group.hidden = visible === 0 && !window.Shopify?.designMode;
        const link = this.links.find(link => link.dataset.category === group.dataset.group);
        if (link) { link.hidden = group.hidden; link.querySelector('small').textContent = visible; }
      });
      this.querySelector('[data-count]').textContent = (words.length ? this.dataset.resultsLabel : this.dataset.countLabel).replace('{count}', String(count));
      this.querySelector('.rp-faq-empty').hidden = count !== 0;
      const first = this.groups.find(group => !group.hidden);
      this.activate(first?.dataset.group);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
})();
